module.exports = __webpack_public_path__ + "img/d_v2.94014eb.png";